
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import {
    ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
    SwitchControlSchema, DateTimeControlSchema, TextAreaControlSchema
} from 'tnx-shared';

@Component({
    selector: 'module-form',
    templateUrl: './module-form.component.html',
    styleUrls: ['./module-form.component.scss'],
    providers: [ComponentContextService],
})
export class ModuleFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _moduleService: ModuleService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._moduleService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'code',
                label: 'Mã',
                required: true
            }),
            new TextControlSchema({
                field: 'name',
                label: 'Tên',
                required: true
            }),
            new TextControlSchema({
                field: 'orderNo',
                label: 'Thứ tự',
                dataFormat: 'number',
                mdWidth: 12
            }),
            new TextAreaControlSchema({
                field: 'description',
                label: 'Mô tả',
                mdWidth: 12
            })
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

